import React, { useState } from 'react';
import { Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { usePermissions } from '../../../../utils/usePermissions';
import ReportHistoryDrawer from './ReportHistoryDrawer';
import { HistoryContext } from './historyApi';

/** Код права, включающего кнопку «История» (первое право набора reports.history.*) */
export const HISTORY_VIEW_PERM = 'reports.history.view';

/**
 * Кнопка «История» экрана отчётности. Без права reports.history.view не показывается;
 * по каким аптекам и с какими подробностями открыть историю, решает сервер (reports.history.pharmacies / .details).
 */
const ReportHistoryButton: React.FC<HistoryContext> = ({ screen, pharmacy, period }) => {
  const { hasPerm } = usePermissions();
  const [open, setOpen] = useState(false);

  if (!hasPerm(HISTORY_VIEW_PERM)) return null;

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<HistoryIcon />}
        onClick={() => setOpen(true)}
        sx={{
          textTransform: 'none', fontWeight: 600, borderRadius: '8px', color: '#334155', borderColor: '#cbd5e1',
          '&:hover': { borderColor: '#94a3b8', backgroundColor: '#f8fafc' }
        }}
      >
        История
      </Button>
      {open && <ReportHistoryDrawer context={{ screen, pharmacy, period }} onClose={() => setOpen(false)} />}
    </>
  );
};

export default ReportHistoryButton;
